'use client';
/**
 * Format string to upper case the first letter and lower case the remaining characters
 * @param {string} str
 * @returns capitalized string, like "Diamond hands"
 */
const capitalize = (str) => {
    return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
};

export { capitalize };
//# sourceMappingURL=capitalize.js.map
